import * as React from 'react'
import { MessageBlock, MessageTypes, Text } from 'DVWebNodeUI'
import { DVString, RequestContext, WPSClient } from '@utils'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { stringifyOnClient } from '../../utils/utils'

export interface ICrowBannerProps {
  title: DVString
  body: DVString
  csrfToken: string
  context: RequestContext
}

const dismissHandler = async (context: RequestContext, csrfToken: string) => {
  const wpsClient = new WPSClient()

  await wpsClient.SetPreferences({
    context,
    csrfToken,
    sessionBased: stringifyOnClient({
      crowBannerOptOut: true,
    }) as WpsRuntime.atv.wps.SetSessionBasedPreferencesInput,
  })
}

export const CrowBanner = ({
  title,
  context,
  csrfToken,
  body,
}: ICrowBannerProps) => (
  <MessageBlock
    heading={title.string}
    type={MessageTypes.warning}
    dismissable={true}
    onDismiss={() => {
      dismissHandler(context, csrfToken)
    }}
  >
    <Text string={body} />
  </MessageBlock>
)
